// Copied verbatim from original/src/components/SidebarItem.tsx (ADR-08 §2.1); only the import path of itemVariants changed.
import React from 'react';
import { motion } from 'motion/react';
import { itemVariants } from '../constants.js';

interface SidebarItemProps {
  icon: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
  collapsed: boolean;
  hidden?: boolean;
  themeColor: string;
  lang: string;
}

export function SidebarItem({ icon, label, active, onClick, collapsed, hidden, themeColor, lang }: SidebarItemProps) {
  if (hidden) return null;
  
  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`
        w-full flex items-center gap-3 px-3.5 py-2.5 rounded-2xl transition-all relative group overflow-hidden cursor-pointer
        ${active 
          ? 'text-white shadow-lg' 
          : 'text-gray-400 hover:text-white hover:bg-white/[0.08]'}
        ${collapsed ? 'justify-center px-2 py-3' : ''}
      `}
      style={active ? { 
        background: `linear-gradient(135deg, ${themeColor || '#f97342'} 0%, ${themeColor ? themeColor : '#ea580c'} 100%)`, 
        boxShadow: `0 8px 24px -4px ${themeColor || '#f97342'}66, inset 0 1px 1px 0 rgba(255,255,255,0.4)`,
      } : {}}
    >
      {/* Subtle top inner reflection for active state */}
      {active && (
        <div className="absolute inset-x-0 top-0 h-[1px] bg-gradient-to-r from-transparent via-white/50 to-transparent" />
      )}
      
      <div className={`relative z-10 flex items-center justify-center shrink-0 ${active ? 'filter drop-shadow-[0_0_6px_rgba(255,255,255,0.4)]' : 'group-hover:scale-110 transition-transform duration-200'}`}>
        {icon}
      </div>
      
      {!collapsed && (
        <span className={`font-bold text-xs tracking-tight relative z-10 transition-colors truncate ${active ? 'text-white font-black' : 'text-gray-300 group-hover:text-white'}`}>
          {label}
        </span>
      )}

      {/* Active Dot Indicator */}
      {active && !collapsed && (
        <motion.div 
          layoutId="active-dot"
          className="ms-auto w-1.5 h-1.5 bg-white rounded-full shadow-[0_0_6px_white]"
        />
      )}
    </motion.button>
  );
}
